<template>
  <div class="sub-routes">
    <section class="section"
             id="createNewObject">
      <el-form :label-position="labelPosition"
               :inline="true"
               :model="formInline"
               ref="formInline"
               class="demo-form-inline ceshi"
               :rules="rules"
               label-width="80px"
               size="medium">
        <el-row style="padding:20px 40px;margin: 0;">
          <h3>
            <i></i>基本信息
          </h3>

          <el-row class="items">
            <el-col :span="10">
              <el-form-item label="对象名称"
                            prop="user">
                <el-input style="width:100%"
                          :disabled="isRead"
                          v-model="formInline.user"
                          maxlength="20"
                          placeholder="请输入随访/调查对象名称"></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="8">
              <el-form-item label="随访类型"
                            prop="follow_code">
                <el-select v-model="formInline.follow_code"
                           :disabled="isRead"
                           style="width:200px"
                           filterable
                           @visible-change="changeValue1($event)"
                           @change="selectFollowType($event)"
                           placeholder="请选择随访类型">
                  <el-option v-for="(item, index) in follow"
                             :key="index"
                             :label="item.follow_name"
                             :value="item.follow_code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row class="items">
            <el-col :span="10">
              <el-form-item label="对象源"
                            prop="person_status">
                <el-select v-model="formInline.person_status"
                           :disabled="isRead"
                           style="width:200px"
                           filterable
                           @change="onSelect($event)"
                           placeholder="请选择对象源">
                  <el-option v-for="(item, index) in object"
                             :key="index"
                             :label="item.statusName"
                             :value="item.person_status"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">

              <el-form-item label="有效期至"
                            prop="person_end_time">
                <el-date-picker @change="changeTime"
                                :disabled="isRead"
                                v-model="formInline.person_end_time"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="请选择有效期"
                                align="right"
                                :picker-options="pickerOptions_"></el-date-picker>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row class="items">
            <el-form-item label="备注">
              <el-input type="textarea"
                        :disabled="isRead"
                        :rows="5"
                        placeholder="请简单描述该随访对象的人员情况，计划用途，人员筛选条件等"
                        v-model="mark"
                        maxlength="70"
                        show-word-limit
                        style="width: 400px;"></el-input>
            </el-form-item>
          </el-row>
        </el-row>
        <el-row style="padding:20px 40px"
                v-show="menzhen">
          <h3>
            <i></i>筛选条件
          </h3>
          <el-row>
            <el-col :span="10">
              <el-form-item label="选择科室">
                <el-select clearable
                           :disabled="isRead"
                           filterable
                           @visible-change="changeSelect($event)"
                           v-model="formInline.dept_code"
                           @change="selectDept($event)"
                           placeholder="请选择科室">
                  <el-option v-for="(item, index) in deptList"
                             :key="index"
                             :label="item.dept_name"
                             :value="item.dept_code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="来院日期">
                <el-date-picker v-model="formInline.value1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="患者性别">
                <el-select v-model="formInline.sex"
                           :disabled="isRead"
                           placeholder="请选择患者性别">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="患者年龄">
                <input type="number"
                       :disabled="isRead"
                       v-model="age1"
                       @keyup="proving1($event)"
                       oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                       class="ckinput"
                       min="1"
                       placeholder="请输入起始年龄" />
                <input style="margin-left:13px;"
                       :disabled="isRead"
                       type="number"
                       v-model="age2"
                       placeholder="请输入截止年龄"
                       @keyup="proving1($event)"
                       oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                       class="ckinput"
                       min="1" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row style="padding:20px 40px"
                v-show="benyuan">
          <h3>
            <i></i>筛选条件
          </h3>
          <el-row>
            <el-col :span="10">
              <el-form-item label="选择部门">
                <el-select v-model="formInline.dept_code"
                           :disabled="isRead"
                           clearable
                           @visible-change="changeSelect($event)"
                           @change="selectDept($event)"
                           placeholder="请选择部门">
                  <el-option v-for="(item, index) in deptList"
                             :key="index"
                             :label="item.dept_name"
                             :value="item.dept_code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="入职时间">
                <el-date-picker v-model="formInline.value1"
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="员工性别">
                <el-select v-model="formInline.sex"
                           :disabled="isRead"
                           placeholder="请选择员工性别">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="员工年龄">
                <input type="number"
                       v-model="age1"
                       :disabled="isRead"
                       @keyup="proving1($event)"
                       class="ckinput"
                       min="1"
                       placeholder="请输入起始年龄" />
                <input style="margin-left:13px;"
                       type="number"
                       :disabled="isRead"
                       v-model="age2"
                       placeholder="请输入截止年龄"
                       @keyup="proving1($event)"
                       class="ckinput"
                       min="1" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row style="padding:20px 40px"
                v-show="ChronicType">
          <h3>
            <i></i>筛选条件
          </h3>
          <el-row>
            <el-col :span="10">
              <el-form-item label="筛查问卷">
                <Cascader :data="quesList"
                          id='xiala'
                          style="width:217px;height:36px"
                          v-model="group"
                          trigger="hover"
                          @on-change="selectQues"></Cascader>

              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="筛查时间"
                            :disabled="isRead">
                <el-date-picker v-model="groupTime"
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.groupTimeOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="所属分组">
                <Cascader :data="groupList"
                          id='xiala'
                          style="width:217px;height:36px"
                          v-model="group"
                          trigger="hover"
                          @on-change="selectQues"></Cascader>

              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="入组时间">
                <el-date-picker v-model="Chronic"
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="所属标签">
                <el-select v-model="formInline.sex"
                           :disabled="isRead"
                           placeholder="请选择所属标签">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="年 龄 段">
                <input type="number"
                       v-model="age1"
                       style="width:165px"
                       :disabled="isRead"
                       @keyup="proving1($event)"
                       class="ckinput"
                       min="1"
                       placeholder="请输入起始年龄" />
                <input style="margin-left:13px;width:165px"
                       type="number"
                       :disabled="isRead"
                       v-model="age2"
                       placeholder="请输入截止年龄"
                       @keyup="proving1($event)"
                       class="ckinput"
                       min="1" />
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="性 别">
                <el-select v-model="sex"
                           :disabled="isRead"
                           placeholder="请选择员工性别">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="是否确诊">
                <el-radio-group v-model="diagnosis">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>

        <el-row style="padding:20px 40px"
                v-show="manbing">
          <h3>
            <i></i>筛选条件
          </h3>
          <el-row>
            <el-col :span="8">
              <el-form-item label="所属标签">
                <el-select v-model="formInline.sex"
                           :disabled="isRead"
                           placeholder="请选择所属标签">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="签约状态">
                <el-select v-model="formInline.sex"
                           :disabled="isRead"
                           placeholder="请选择所属标签">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入组时间">
                <el-date-picker v-model="Chronic"
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>

          </el-row>
        </el-row>

        <el-form-item style="text-align: center;width: 100%;padding-bottom: 20px;">
          <el-button type="primary"
                     size="medium"
                     @click="onSubmit('formInline')">保存</el-button>
          <el-button type="info"
                     size="medium"
                     @click="onCancle">取消</el-button>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import { Message, MessageBox, Loading } from 'element-ui'
let qs = require('qs')

export default {
  name: 'createNewObject',
  props: {
    id: '',
    type: '',
  },
  data() {
    return {
      ChronicType: false,
      externalDdata: require('./createObjectData.js').allObj,
      ques: [],
      quesList: [],
      groupList: [],
      group: [],
      value: '',
      sex: '',
      diagnosis: '',
      formInline: {
        user: '',
        follow_code: '',
        person_status: '',
        person_end_time: '',
        dept_code: '',
        sex: '',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
      },
      isRead: false,
      // 校验
      rules: {
        user: [
          {
            required: true,
            message: '请输入随访/调查对象名称',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 20,
            message: '长度在 2 到 20 个字符',
            trigger: 'blur',
          },
        ],
        follow_code: [
          { required: true, message: '请选择随访类型', trigger: 'change' },
        ],
        person_status: [
          { required: true, message: '请选择对象源', trigger: 'change' },
        ],

        value1: [
          { required: true, message: '请选择来院日期', trigger: 'change' },
        ],

        value2: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ],
        value3: [
          { required: true, message: '请选择开始日期', trigger: 'change' },
        ],
        value4: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ],
      },
      pickerOptions_: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      age1: '',
      age2: '',
      groupTime: '',
      Chronic: '',
      followCode:"",
      menzhen: true,
      zhuyuan: false,
      benyuan: false,
      manbing: false,
      follow: [],
      deptList: [],
      object: [],
      mark: '',
      follow_name: '',
      // room_name: '',
      dept_name: '',
      labelPosition: 'left',
      loading: false,
      object_: '',
   
    }
  },
  components: {},
  watch: {},
  methods: {
    selectQues(value, selectedData) {
      console.log(value, selectedData)
      this.quesId = selectedData[1].questionnaire_id
      // this.type_id = selectedData[1].type_id
      // this.questionnaire_name = selectedData[1].name
    },
    changeSelect(event) {
      if (event) {
        this.getDept()
        // this.getPerson()
      }
    },

    openloading() {
      // debugger
      console.log(document.querySelector('.ceshi'))
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        target: document.querySelector('.ceshi'), // 指定区域
      })
    },
    selectFollowType(id) {
      this.ChronicType = false
      this.benyuan = false
      this.menzhen = false
      this.manbing = false
      let obj = {}
      let newObjectsource = []
      this.follow.find((item) => {
        if (item.follow_code === id) {
          this.follow_name = item.follow_name
          obj = item
        }
      })

      if (obj.person_type_codes) {
        this.object_.forEach((value) => {
          obj.person_type_codes.forEach((val) => {
            if (val == value.person_status) {
              newObjectsource.push(value)
            }
          })
        })
      }
      let ChronicType = this.follow.find((res) => res.follow_code == id)
      if (newObjectsource.length) {
        this.formInline.person_status = newObjectsource[0].person_status
      } else {
        newObjectsource = this.object_
        this.formInline.person_status = ''
      }

      this.object = newObjectsource
      if (
        this.formInline.person_status === '0' ||
        this.formInline.person_status === '1'
      ) {
        this.getDept()
      }
      if (
        this.formInline.person_status === '0' ||
        this.formInline.person_status === '1'
      ) {
        this.menzhen = true

        this.rules.value1 = [
          { required: true, message: '请选择来院日期', trigger: 'change' },
        ]

        this.rules.value2 = [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ]
        delete this.rules.value3
        delete this.rules.value4
      } else if (ChronicType.follow_name == '筛查中心随访') {
        this.ChronicType = true
        delete this.rules.value1
        delete this.rules.value2
        delete this.rules.value3
        delete this.rules.value4
      } else if (this.formInline.follow_code == '1280309721538105333') {
        this.manbing = true
      } else {
        this.benyuan = true
        this.rules.value3 = [
          { required: true, message: '请选择开始日期', trigger: 'change' },
        ]
        this.rules.value4 = [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ]
        delete this.rules.value1
        delete this.rules.value2
      }
    },
    selectDept(id) {
      let obj = {}
      obj = this.deptList.find((item) => {
        // if (item.room_code === id) {
        //   this.dept_name = item.dept_name
        // }
        if (item.dept_code === id) {
          this.dept_name = item.dept_name
        }
      })
    },
    changeTime(value) {
      if (value == null) {
        this.formInline.person_end_time = ''
      }
    },

    onSelect(val) {
      console.log(val)
      // 0-门诊患者,1-住院患者,2-本院职工
      if (val === '0' || val === '1') {
        this.menzhen = true
        // this.zhuyuan = false
        this.benyuan = false

        this.rules.value1 = [
          { required: true, message: '请选择来院日期', trigger: 'change' },
        ]

        this.rules.value2 = [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ]
        delete this.rules.value3
        delete this.rules.value4
      } else {
        this.benyuan = true
        this.menzhen = false
        this.rules.value3 = [
          { required: true, message: '请选择开始日期', trigger: 'change' },
        ]
        this.rules.value4 = [
          { required: true, message: '请选择结束日期', trigger: 'change' },
        ]
        delete this.rules.value1
        delete this.rules.value2
      }
    },

    onSubmit(formName) {
      let self = this
      self.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          var name = self.formInline.user //对象名称
          var follow_code = self.formInline.follow_code //随访类型
          var person_status = self.formInline.person_status //对象源
          var person_end_time = ''
          if (self.formInline.person_end_time) {
            person_end_time = self.formInline.person_end_time + ' 23:59:59' //有效期
          }
          var remark = self.mark //备注
          // var room_code = self.formInline.room_code //科室
          var value1 = self.formInline.value1 //来院日期
          var value2 = self.formInline.value2 //来院日期
          var value3 = self.formInline.value3 //来院日期
          var value4 = self.formInline.value4 //来院日期
          var sex = self.formInline.sex //性别
          var age1 = self.age1 //年龄
          var age2 = self.age2
          var dept_code = self.formInline.dept_code //部门
          if (!parseInt(age1) && parseInt(age2)) {
            Message.warning({
              message: '请输入起始年龄',
            })
            return
          }
          if (!parseInt(age2) && parseInt(age1)) {
            Message.warning({
              message: '请输入截止年龄',
            })
            return
          }
          if (parseInt(age2) < parseInt(age1)) {
            Message.warning({
              message: '年龄输入有误，请重新输入',
            })
            return
          }
          console.log('value1', value1, value2)

          if (self.benyuan) {
            var oDate3 = new Date(value3)
            var oDate4 = new Date(value4)
            if (oDate3.getTime() > oDate4.getTime()) {
              Message.warning({
                message: '入职时间选择有误',
              })
              return //第一个大
            }
          } else {
            var oDate1 = new Date(value1)
            var oDate2 = new Date(value2)
            if (oDate1.getTime() > oDate2.getTime()) {
              Message.warning({
                message: '来院日期选择有误',
              })
              return //第一个大
            }
          }

          // 创建对象
          let age = [age1, age2]

          let time = [value1, value2]

          if (self.benyuan) {
            time = [value3, value4]
          }

          let params = {
            follow_person_name: name.trim(),
            follow_type_code: follow_code,
            follow_type_name: self.follow_name,
            person_status: person_status,
            remark: remark.trim(),
            room_code: dept_code,
            room_name: self.dept_name,
            come_time: time ? time.toString() : '',
            age_start: age.toString(),
            sex: sex,
            person_end_time: person_end_time,
            choose_flag: 0,
          }

          self.openloading()
          if (this.type == 'modify') {
            params.follow_person_code = self.follow_person_code
            params.status = self.tableData.status
            self.$utils.caringRequest({
              method: 'post',
              url: self.$utils.getInterface('UPDATE_LIST'),
              data: params,
              success: (res) => {
                if (res.code == 0) {
                  Message.success({
                    message: '修改成功',
                  })
                } else {
                  Message.warning({
                    message: res.message,
                  })
                }
              },
            })
          } else {
            self.$utils.caringRequest({
              method: 'post',
              url: self.$utils.getInterface('CREATE_LIST'),
              data: params,
              success: (res) => {
                self.loading.close()
                if (res.code == 0) {
                  Message.success({
                    message: '创建成功',
                  })
                  self.refesh()
                  self.$store.commit('setActiveKey', `objectList`)
                  self.$store.commit('setAllSelectedKeys', {
                    type: 'delete',
                    name: 'createNewObject',
                    title: '创建随访对象',
                    key: 'createNewObject',
                  })
                } else {
                  Message.warning({
                    message: res.message,
                  })
                }
              },
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'objectList') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'objectList') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
    onCancle() {
      let allSelectedKeys = this.$store.getters.allSelectedKeys,
        lastIndex
      allSelectedKeys.forEach((pane, i) => {
        if (pane.key === 'createNewObject') {
          lastIndex = i - 1
        }
      })
      if (allSelectedKeys.length) {
        if (lastIndex >= 0) {
          this.$store.commit('setActiveKey', allSelectedKeys[lastIndex].key)
        } else {
          this.$store.commit('setActiveKey', allSelectedKeys[0].key)
        }
      }
      this.$store.commit('setAllSelectedKeys', {
        type: 'delete',
        name: 'createNewObject',
        title: '创建随访对象',
        key: 'createNewObject',
      })
    },
    // 获取随访类型列表
    geFollowType() {
      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface('FOLLOW_TYPE'),
        success: (res) => {
          if (res.code == '0') {
            this.follow = res.data
            console.log(res.data)
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
      })
    },

    // 对象源列表
    getPerson() {
      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface('PERSON_SOURCE'),
        success: (res) => {
          if (res.code == '0') {
            this.object = res.data
            this.object_ = res.data
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
      })
    },
    // 科室列表
    getDept() {
      this.$utils.caringRequest({
        method: 'get',
        url:
          this.$utils.getInterface('QUERY_ROOM') +
          '/' +
          this.formInline.person_status,
        success: (res) => {
          if (res.code == '0') {
            this.deptList = res.data
            if (this.type == 'modify' || this.type == 'read-only') {
              this.formInline.dept_code = this.tableData.room_code
            }
          } else {
            Message.warning({
              message: '请先选择随访类型',
            })
          }
        },
      })
    },

    changeValue1(event) {
      //       if (event) {
      //         this.geFollowType()
      //       }
    },
    getDetail() {
      let self = this
      let query = {
        id: self.id,
      }
      self.openloading()
      self.$utils.caringRequest({
        method: 'get',
        url:
          self.$utils.getInterface('QUERY_DETAIL') + '?' + qs.stringify(query),
        success: (res) => {
          console.log(res.code)
          self.loading.close()
          if (res.code == '0') {
            let tableData = res.data
            self.tableData = tableData
            let age = tableData.age_start.split(',')
            let come_time = tableData.come_time.split(',')
            self.age1 = age[0]
            self.age2 = age[1]
            self.time = come_time
            self.formInline.sex = tableData.sex + ''

            self.formInline.user = tableData.follow_person_name //对象名称
            self.formInline.follow_code = tableData.follow_type_code //随访类型
            self.formInline.person_status = tableData.person_status //对象源
            self.formInline.person_end_time = tableData.person_end_time
            if (tableData.person_status == 1) {
              if (tableData.task_info_list_entities) {
                self.disable = true
              }
            }

            self.formInline.remark = tableData.remark //备注
            // self.room_code = tableData.room_code //科室
            // self.room_name = tableData.room_name
            //     self.dept_code = tableData.room_code //部门
            self.dept_name = tableData.room_name
            self.follow_name = tableData.follow_type_name
            self.follow_person_code = tableData.follow_person_code
            console.log(self.follow_person_code)
            self.sex_code = tableData.sex //性别
            // 0-门诊患者,1-住院患者,2-本院职工
            this.getDept(tableData.person_status)
            if (tableData.person_status === '2') {
              self.menzhen = false
              self.benyuan = true
              // self.zhuyuan = false

              self.formInline.value3 = come_time[0]
              self.formInline.value4 = come_time[1]
              self.rules.value3 = [
                {
                  required: true,
                  message: '请选择开始日期',
                  trigger: 'change',
                },
              ]
              self.rules.value4 = [
                {
                  required: true,
                  message: '请选择结束日期',
                  trigger: 'change',
                },
              ]

              delete self.rules.value1
              delete self.rules.value2
            }
            // else if (tableData.person_status === '1') {
            //   self.benyuan = false
            //   self.menzhen = false
            //   self.zhuyuan = true
            // }
            else {
              // self.zhuyuan = false
              self.benyuan = false
              self.menzhen = true

              self.formInline.value1 = come_time[0]
              self.formInline.value2 = come_time[1]
              self.rules.value1 = [
                {
                  required: true,
                  message: '请选择来院日期',
                  trigger: 'change',
                },
              ]

              self.rules.value2 = [
                {
                  required: true,
                  message: '请选择结束日期',
                  trigger: 'change',
                },
              ]
              delete self.rules.value3
              delete self.rules.value4
            }
          } else {
            Message.warning({
              message: res.message,
            })
          }
        },
      })
    },
    //      验证只能输入正整数
    proving1(e) {
      console.log(e)
      var str = e.target.value
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)

      var keynum = window.event ? e.keyCode : e.which //获取键盘码
      var keychar = String.fromCharCode(keynum) //获取键盘码对应的字符
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 69) {
        // this.$Message.warning('禁止输入小数以及负数')
        e.target.value = ' '
      }
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        e.target.value = str.substr(1, 1)
      }
      if (str > 130) {
        e.target.value = ''
      }
    },
    selectList(url, team_id, type) {
      let header = {}
      if (team_id) {
        header.team_id = team_id
      }
      this.$utils.caringRequest({
        method: 'GET',
        url: url,
        headers: header,
        success: (res) => {
          if (res.code === 0) {
            let ques = res.data
            for (let i = ques.length - 1; i >= 0; i--) {
              if (ques[i][type].length > 0) {
                ques[i].value = ques[i].id
                ques[i].label = ques[i].name
                ques[i].children = ques[i][type]
                ques[i].children.forEach(function (j) {
                  j.value = j.id
                  j.label = j.name
                })
              } else {
                ques.splice(i, 1)
              }
            }
            if (team_id) {
              this.groupList = ques
            } else {
              this.quesList = ques
            }
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
  },
  mounted() {},

  created() {
    if (this.type == 'modify') {
      this.getDetail()
    } else if (this.type == 'read-only') {
      this.isRead = true
      this.getDetail()
    }
    this.geFollowType()
    this.getPerson()
    //
  },
}
</script>
<style lang="less" scoped>
// @import '../../../assets/common.scss';

#createNewObject {
  // background-color: #f1f3f9;
  .quest-title {
    // width: 100%;
    height: 50px;
    line-height: 50px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(234, 238, 247, 1);
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(116, 130, 154, 1);
    span {
      margin-left: 30px;
    }
  }
  .el-row {
    background: #ffffff;
    margin: 20px 0;
    h3 {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: rgba(255, 175, 21, 1);
      margin: 0;
      display: flex;
      align-items: center;
      i {
        width: 4px;
        height: 14px;
        background: rgba(255, 175, 19, 1);
        border-radius: 2px;
        margin-right: 5px;
      }
    }
    .el-form-item {
      margin-bottom: 0;
      span {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(179, 193, 211, 1);
      }
    }
    .el-table {
      margin-top: 15px;
      th,
      td {
        text-align: center;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(115, 129, 153, 1);
      }
    }
  }
  .items {
    display: flex;
    align-items: center;
    margin: 10px 0 20px;
    .el-form-item {
      flex: 1;
    }
  }
}

/* 设置所有input宽度一致 */
.el-input {
  width: 200px !important;
}
.ckinput {
  width: 200px;
  height: 36px;
  padding-left: 15px;
  padding-top: 2px;
  border: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
.ckinput::-webkit-input-placeholder {
  color: #bbbfc8;
}
.ckinput::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bbbfc8;
}
.ckinput:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bbbfc8;
}
.ckinput:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #bbbfc8;
}
.ckinput:focus {
  outline: none;
}
.ivu-input-inner-container {
  .ivu-input {
    height: 36px !important;
  }
  .ivu-input-default {
    height: 36px !important;
  }
}
.ivu-input {
  height: 36px !important;
}
</style>